import { svg } from 'lit';

const symbol = svg`<svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.991 8.323a6 6 0 11-6.315-6.315c.27-.014.411.307.268.536a4 4 0 005.512 5.512c.23-.144.55-.003.535.267z" stroke="currentColor" stroke-width=".667" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

export { symbol as default };
